import React from 'react';
import BrandTypography from '@justpark/ui/src/components/BrandTypography';
import Typography from '@justpark/ui/src/components/Typography';
import Heading from '@justpark/ui/src/components/Heading';
import CmsContent from '../CmsContent';

import styles from '../../../static/scss/components/landing/topAttractions.module.scss';

type Props = {
  heading: string,
  subHeading: string,
  content: string
};

const TopAttractions = ({ heading, subHeading, content }: Props) => (
  <div className={styles.base}>
    <BrandTypography level={2} bold>
      <CmsContent content={heading} />
    </BrandTypography>
    {!!subHeading && (
      <Heading level={3} className={styles.description} bold>
        <p>{subHeading}</p>
      </Heading>
    )}
    <Typography>
      <div>
        <CmsContent content={content} />
      </div>
    </Typography>
  </div>
);

export default TopAttractions;
